import React from 'react';
import { useComponentTranslations } from '@core/js/hooks/component';

import { ACTIVE_TAB_POPUP } from './../../constants';
import * as Types from './../../types';

import style from './CookieTabSwitcher.scss';

export const CookieTabSwitcher: React.FC<Types.ICookieTabSwitcherProps> = ({
    activeTab,
    setActiveTab
}) => {
    const translate = useComponentTranslations();

    const tabs = [
        { id: ACTIVE_TAB_POPUP.MESSAGE, label: 'navTabMessage' },
        { id: ACTIVE_TAB_POPUP.SETTING, label: 'navTabSettings' }
    ];

    return (
        <>
            {tabs.map(tab => (
                <span
                    key={tab.id}
                    className={`${style.tab} ${activeTab === tab.id ? style.active : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                >
                    {translate(tab.label)}
                </span>
            ))}
        </>
    );
};
